import PermissionService from '@/js/permissions'

export default {
  data () {
    return {
      permissionService: new PermissionService(),
    }
  },
  methods: {
    isForbidden (pageName, resourceName, actionName) {
      const result = this.permissionService.isChildrenForbidden(
        pageName, resourceName, actionName, this.$store.getters.myRoleInfo.permissions
      )

      return result
    },
  },
}
